import { useEffect, useRef } from "react";

export function useDidUpdateEffect(effect, deps) {
  const mount = useRef(false)

  useEffect(() => {
    if (mount.current) return effect()
    mount.current = true
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}
